/*
ShareModal.js
Adam Berger
July 2023

Sharing works like the mobile app: the Share button hands the recipe link to
the browser's native share sheet (see shareRecipe in pages/Detail/useDetail.jsx).
This dialog is the fallback for browsers without one: copy the link, or open
the user's own email app with it filled in.
*/

import React from 'react';
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CopyToClipboard from "./CopyToClipboard";

//import assets
import modalX from "assets/icons/modal-x.svg";
import share from "assets/icons/share.svg";

// Same wording and link as the mobile app's handleShare in app/recipe/[id].tsx.
// Change one, change the other.
export function buildShareData(guid, recipeName) {
  return {
    title: "Check out this recipe on Kasserole!",
    text: `Check out this recipe on Kasserole: ${recipeName || "this recipe"}`,
    url: window.location.origin + "/el/" + guid,
  };
}

export default function ShareModal({ backdrop, toggle, guid, recipeName, onClick }) {
  const { title, text, url } = buildShareData(guid, recipeName);
  const mailtoHref =
    "mailto:?subject=" + encodeURIComponent(title) +
    "&body=" + encodeURIComponent(text + "\n\n" + url);

  return (
    <div>
      <Modal
        backdrop={backdrop}
        toggle={toggle}
        isOpen={true}
        className="modal-dialog-centered"
      >
        <div className="modal-header">
          <div className="modal-header-flex">
            <h5 className="modal-header-text">Share this recipe</h5>
            <img className="modal-header-x" src={modalX} onClick={onClick} />
          </div>
        </div>
        <ModalBody>
          <div className="share-modal-body-header">
            Here&apos;s a link to this recipe:
          </div>

          <CopyToClipboard textToCopy={url} />

          <div className="share-modal-row share-modal-row-last">
            <a className="share-modal-btn share-modal-btn-dark" href={mailtoHref}>
              <img src={share} />
              Email
            </a>
            <div className="modal-body-text">
              Open your email app with the link filled in.
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

ShareModal.propTypes = {
  guid: PropTypes.string.isRequired,
  recipeName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  backdrop: PropTypes.bool,
  toggle: PropTypes.func,
};
